export const defaultId = 'kernel-image-777';
